export function getAttachedEmailThreads(data) {
  return data.results.objects
}

export function getEmailThreadsFromResponse(data) {
  return { items: data.results.objects }
}
